import { NoteBlank } from "@phosphor-icons/react";
import clsx from "clsx";

import RenderIf from "common/components/RenderIf";

import AddNoteSolidIcon from "assets/icons/note-add-solid.svg?react";

export default function LeadNotesIndicator({
  noteCount,
  onClick,
}: {
  noteCount: number;
  onClick?: () => void;
}) {
  const hasNotes = !!noteCount;
  const containerClassName = clsx(
    "flex items-center hover:bg-black-200 rounded-md gap-x-0.5 p-0.5 group-hover/table-row:text-black-700",
    hasNotes ? "text-black-500" : "text-black-300",
  );
  const content = (
    <>
      <RenderIf condition={!!hasNotes}>{noteCount}</RenderIf>
      <NoteBlank className="size-4 group-hover/table-row:hidden block" />
      <AddNoteSolidIcon className="size-4 group-hover/table-row:block hidden" />
    </>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={containerClassName}>
        {content}
      </button>
    );
  }
  return <div className={containerClassName}>{content}</div>;
}
